import React from 'react'
import '../../Styles/App.css';

export default function Section1() {
    return (
        <div className='flex flex-1 py-10 lg:py-0 grid content-center relative overflow-hidden'>
            <div className='w-[90%] mx-auto relative'>
                <h1 className='mt-5 text-center text-3xl lg:text-4xl 2xl:text-5xl font-semibold '>Discover the Science in Your Stride </h1>
                <p className='capitalize text-center mt-3'>Let your DNA guide you to peak performance! Register now for your personalized DNA test kit and <br className='hidden lg:block'/> discover the genetic insights that could transform your training, nutrition, and recovery.  </p>
                <img src='/assets/others/Dna_sec1.svg' data-aos='flip-down' data-aos-duration='1500' className='w-40 md:w-52 mx-auto'></img>
            </div>
            <div className='absolute bg-gradient-to-r from-[#01F7FF]/5 via-[#01F7FF]/10 to-[#01F7FF]/5 top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%] w-[90%] h-[60%] rounded-[100%] blur-[30px]'></div>
            <div>
                <div className='absolute top-[50%] -translate-y-[50%] left-0 w-20 md:w-52 lg:w-auto'><img src='/assets/others/Dna_sec1_left.svg' data-aos='flip-up' data-aos-duration='1000'></img></div>
                <div className='absolute top-[50%] -translate-y-[50%] right-0  w-20 md:w-52 lg:w-auto'><img src='/assets/others/Dna_sec1_right.svg' data-aos='flip-up' data-aos-duration='1000'></img></div>
            </div>
        </div>
    )
}
